import {GlobalVariables} from "../GlobalVariables";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-full");

        if (this.header) {
            this.overlay = this.header.querySelector(".overlay");
            this.toggleMobileNav();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }
    }

    static openMobileNav() {
        document.body.classList.add("navs-open");
        GlobalVariables.lenis?.stop();
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        GlobalVariables.lenis?.start();
    }

    static resize() {
        this.closeMobileNav();
    }
}
